import React, { Component } from 'react'
import { Button, Checkbox, Col, DatePicker, Form, Input, message, Modal, Popconfirm, Row, Select } from 'antd'
import moment from 'moment'
import _ from 'lodash'
import omitEmpty from 'omit-empty'
import Events from '../../../api/Events'
import { strVal } from '../../../modules/Utils'

const FormItem = Form.Item
const Option = Select.Option
const { TextArea } = Input
const { RangePicker } = DatePicker

class EditEvent extends Component {
  api = new Events()
  state = { loading: false, removing: false }
  handleSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        let event = Object.assign({}, values)
        event.start = {
          date: values.dateRange[0].format('YYYY-MM-DD'),
          dateTime: values.dateRange[0].format(),
          milliseconds: values.dateRange[0].unix(),
        }
        event.end = {
          date: values.dateRange[1].format('YYYY-MM-DD'),
          dateTime: values.dateRange[1].format(),
          milliseconds: values.dateRange[1].unix(),
        }
        event.calendar = { _id: values.calendar }
        event = Object.assign({}, this.props.info, event)
        event = _.omit(event, ['title', 'desc', 'dateRange'])
        event = omitEmpty(event)

        try {
          this.setState({ loading: true })
          await this.api.update(event)
          message.success('Updated!')
          this.props.handleCancel(true)
        } catch (error) {
          this.setState({ loading: false })
          message.error(error.errorMessage)
        }
      }
    })
  }

  handleRemove = async () => {
    try {
      const { _key, _rev, _id } = this.props.info
      this.setState({ removing: true })
      await this.api.remove({ _key, _rev, _id })
      message.success('Removed')
      this.props.handleCancel(true)
    } catch (error) {
      this.setState({ removing: false })
      message.error(error.errorMessage)
    }
  }

  render() {
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    }
    const { getFieldDecorator } = this.props.form
    const { visible, handleOk, calendars, handleCancel, info } = this.props
    return (
      <Modal
        title="Create an Event"
        visible={visible}
        onOk={handleOk}
        onCancel={handleCancel}
        width={763}
        footer={
          <Row>
            <Col span={24} style={{ textAlign: 'right' }}>
              <Button loading={this.state.loading} type="primary" onClick={this.handleSubmit}>
                Update
              </Button>
              <Popconfirm
                title="Are you sure Remove this Event?"
                onConfirm={this.handleRemove}
                okText="Yes"
                cancelText="No">
                <Button loading={this.state.removing} type="danger" style={{ marginLeft: 8 }}>
                  Remove
                </Button>
              </Popconfirm>
              <Button onClick={handleCancel} style={{ marginLeft: 8 }}>
                Close
              </Button>
            </Col>
          </Row>
        }>
        <Form layout="vertical" onSubmit={this.handleSubmit}>
          <FormItem hasFeedback {...formItemLayout} label="Event">
            {getFieldDecorator('name', {
              initialValue: info.name,

              rules: [
                {
                  required: true,
                  message: "Event can't be empty ",
                },
              ],
            })(<Input placeholder="New Event" />)}
          </FormItem>
          <FormItem {...formItemLayout} label="All-Day">
            {getFieldDecorator('allDay', {
              valuePropName: 'checked',
              initialValue: info.allDay,
            })(<Checkbox />)}
          </FormItem>

          <FormItem {...formItemLayout} label="Description">
            {getFieldDecorator('description', {
              initialValue: info.description,
            })(<TextArea placeholder="Event Description" />)}
          </FormItem>
          <FormItem hasFeedback {...formItemLayout} label="Date">
            {getFieldDecorator('dateRange', {
              initialValue: [moment(info.start), moment(info.end)],
              rules: [
                {
                  required: true,
                  message: 'Date range need to be selected ',
                },
              ],
            })(<RangePicker style={{ width: '100%' }} showTime={{ format: 'HH:mm' }} format="ddd YYYY-MM-DD HH:mm" />)}
          </FormItem>

          <FormItem {...formItemLayout} label="Calender">
            {getFieldDecorator('calendar', {
              initialValue: strVal(info, 'calendar._id'),
              rules: [
                {
                  required: true,
                  message: "calender can't be empty ",
                },
              ],
            })(
              <Select placeholder="Select a Calender .. ">
                {calendars.map((c) => (
                  <Option value={c._id}>{c.name}</Option>
                ))}
              </Select>
            )}
          </FormItem>
        </Form>
      </Modal>
    )
  }
}

const WrappedEditEventForm = Form.create()(EditEvent)

export default WrappedEditEventForm
